import { render, staticRenderFns } from "./SelectedFilesList.vue?vue&type=template&id=34b67f28&scoped=true&"
import script from "./SelectedFilesList.vue?vue&type=script&lang=js&"
export * from "./SelectedFilesList.vue?vue&type=script&lang=js&"
import style0 from "./SelectedFilesList.vue?vue&type=style&index=0&id=34b67f28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b67f28",
  null
  
)

export default component.exports